import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * `/suggestions` used to be one queue holding both proposed ticket changes and
 * proposed time entries. They're now two pages, because they're two different
 * decisions made by two different people. Kept as a redirect to the work-item
 * queue — that's what the old link meant to whoever bookmarked it.
 */
export const Route = createFileRoute("/_app/suggestions/")({
  beforeLoad: () => {
    throw redirect({ to: "/suggestions/work-items" });
  },
});
